import React, {useCallback, useEffect, useRef} from 'react';


export default function Modal({
                                  isOpen,
                                  onClose,
                                  title,
                                  subtitle,
                                  children,
                                  size = 'tw-max-w-6xl',
                              }) {
    const dialogRef = useRef(null);


    useEffect(() => {
        if (isOpen && dialogRef.current) dialogRef.current.showModal();
    }, [isOpen]);


    const handleClose = useCallback(() => {
        if (dialogRef.current) dialogRef.current.close();
        onClose?.();
    }, [onClose]);


    if (!isOpen) return null;


    return (
        <dialog
            ref={dialogRef}
            className="tw-modal tw-modal-middle"
            onClose={handleClose}
            onCancel={handleClose}
        >
            <div className={`tw-modal-box tw-w-11/12 ${size} tw-max-h-[90vh]`}>
                {(title || subtitle) && (
                    <div className="tw-bg-primary tw-text-primary-content tw-p-4 tw-rounded-t-lg tw--m-6 tw-mb-6">
                        {title && <h3 className="tw-font-bold tw-text-lg">{title}</h3>}
                        {subtitle && <p className="tw-text-sm tw-opacity-80">{subtitle}</p>}
                    </div>
                )}
                {children}
            </div>
            <div className="tw-modal-backdrop" onClick={handleClose} />
        </dialog>
    );
}
